import React from 'react';
import Router from 'next/router';
import { Layout } from '../../components/Layout';
import { Container } from '../../components/Container';
import { Error, Props as ErrorProps } from '../../components/Error';
type Props = ErrorProps;

// TODO: Should we move into process.env? Which one do we want in error handling?
const REDIRECT_ON_ERROR = false;
export const ErrorPage = (props: Props) => {
  if (REDIRECT_ON_ERROR) {
    Router.push('/');
    return null;
  }
  return <Layout data-sentry-element="Layout" data-sentry-component="ErrorPage" data-sentry-source-file="ErrorPage.tsx">
      <Container data-sentry-element="Container" data-sentry-source-file="ErrorPage.tsx">
        <Error {...props} data-sentry-element="Error" data-sentry-source-file="ErrorPage.tsx" />
      </Container>
    </Layout>;
};